/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeTriangleUpIcon16Light } from './ShapeTriangleUpIcon16Light';
import { ShapeTriangleUpIcon16Regular } from './ShapeTriangleUpIcon16Regular';
import { ShapeTriangleUpIcon16Solid } from './ShapeTriangleUpIcon16Solid';
import { ShapeTriangleUpIcon20Light } from './ShapeTriangleUpIcon20Light';
import { ShapeTriangleUpIcon20Regular } from './ShapeTriangleUpIcon20Regular';
import { ShapeTriangleUpIcon20Solid } from './ShapeTriangleUpIcon20Solid';
import { ShapeTriangleUpIcon24Regular } from './ShapeTriangleUpIcon24Regular';
import { ShapeTriangleUpIcon24Solid } from './ShapeTriangleUpIcon24Solid';
import { ShapeTriangleUpIcon32Regular } from './ShapeTriangleUpIcon32Regular';
import { ShapeTriangleUpIcon64Regular } from './ShapeTriangleUpIcon64Regular';
var sizes = {
    16: {
        light: ShapeTriangleUpIcon16Light,
        regular: ShapeTriangleUpIcon16Regular,
        solid: ShapeTriangleUpIcon16Solid,
    },
    20: {
        light: ShapeTriangleUpIcon20Light,
        regular: ShapeTriangleUpIcon20Regular,
        solid: ShapeTriangleUpIcon20Solid,
    },
    24: {
        regular: ShapeTriangleUpIcon24Regular,
        solid: ShapeTriangleUpIcon24Solid,
    },
    32: {
        regular: ShapeTriangleUpIcon32Regular,
    },
    64: {
        regular: ShapeTriangleUpIcon64Regular,
    },
};
export var ShapeTriangleUpIcon = forwardRef('ShapeTriangleUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
